;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$state", "glError"];
  angular.module('app.error').controller('Error', Controller)

  /* @ngInject */
  function Controller($scope, $state, glError) {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      ctrl.error = glError.get()
    }
  }
})()
